import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar"
import {
  languageOptions,
  useTranslation,
} from "@/hooks/useTranslation/useTranslation"
import useUser from "@/hooks/useUser"
import { userDisplayName, userInitials } from "@/utils/userIdentity"
import { IconWorld } from "@tabler/icons-react"
import { Check, ChevronsUpDown, LogOut } from "lucide-react"

export const SidebarUserMenu = () => {
  const { translate, changeLanguage, currentLanguage } = useTranslation()
  const { user, handleLogout } = useUser()
  // Email-like display names (Cognito often uses the email as username) are
  // shortened to the local part for the primary label; the full email still
  // shows on the secondary line via the email !== name check below.
  const name = user ? userDisplayName(user) : ""

  return (
    <SidebarMenuItem>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <SidebarMenuButton
            className="h-11"
            aria-label={translate("SIDEBAR/ACCOUNT")}
          >
            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary text-xs font-semibold group-data-[collapsible=icon]:h-5 group-data-[collapsible=icon]:w-5">
              {userInitials(name)}
            </span>
            <span className="flex min-w-0 flex-col text-left">
              <span className="truncate text-sm font-medium">{name}</span>
              {user?.email && user.email !== name ? (
                <span className="truncate text-xs text-muted-foreground">
                  {user.email}
                </span>
              ) : null}
            </span>
            <ChevronsUpDown
              className="ml-auto h-4 w-4 text-muted-foreground"
              aria-hidden="true"
            />
          </SidebarMenuButton>
        </DropdownMenuTrigger>
        <DropdownMenuContent side="top" align="start" className="w-56">
          <DropdownMenuSub>
            <DropdownMenuSubTrigger>
              <IconWorld className="h-4 w-4" />
              {translate("SIDEBAR/LANGUAGE")}
            </DropdownMenuSubTrigger>
            <DropdownMenuSubContent>
              {languageOptions.map((option) => (
                <DropdownMenuItem
                  key={option.key}
                  onSelect={() => changeLanguage(option.key)}
                >
                  {option.name}
                  {option.key === currentLanguage ? (
                    <Check className="ml-auto h-4 w-4" aria-hidden="true" />
                  ) : null}
                </DropdownMenuItem>
              ))}
            </DropdownMenuSubContent>
          </DropdownMenuSub>
          <DropdownMenuSeparator />
          <DropdownMenuItem onSelect={handleLogout}>
            <LogOut className="h-4 w-4" />
            {translate("SIDEBAR/LOGOUT")}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </SidebarMenuItem>
  )
}
